import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class AlertHelp16Icon extends BaseIcon {
  getChildren = () => [
    <path d="M8 0a8 8 0 1 0 8 8 8 8 0 0 0-8-8Zm0 14.5A1.5 1.5 0 1 1 9.5 13 1.5 1.5 0 0 1 8 14.5ZM8.92 8v1a.92.92 0 0 1-1.84 0V7.64a1.42 1.42 0 0 1 1.14-1.38.93.93 0 1 0-1.15-.91.92.92 0 0 1-1.84 0A2.77 2.77 0 1 1 8.92 8Z" fill="#3b8fd6"/>
    ]
  getViewBox = () => '0 0 16 16'
}
